import styled from "styled-components";

import img from "assets/marcayoutube.a7012f7196647ca7.jpg";

export const Background = styled.figure`
  background: url(${img}) no-repeat center;
  background-size: cover;
`;
